import React, { Component } from "react";
import SuggestACharity from "./Components/SuggestACharity";
import SACConfitmationPage from "./Components/SACConfirmationPage";
import { getPrimaryAccount } from '../../../../utils/sessionUtil';
import { ContentProvider, Types, ContentMessage } from '../../../../CommonComponents/ContentMessages';
import AlertBox from '../../../../CommonComponents/AlertBox';

class SACComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      frozen: false,
      heading: {
        suggestTitle: "Suggest a charity",
        suggestBtnText: "Suggest",
        backBtnText: "Back"
      }     
    };

    this.validate = this.validate.bind(this);
    this.frozenPopUp = {
      heading: "Account Locked",
      line1: "<p>This account is frozen. Contact us at 888-383-4483.</p>",
      continue: "Continue"     
    };
  }

  componentWillMount() {
    if(getPrimaryAccount().freezes && getPrimaryAccount().freezes.length > 0) {
      this.setState({
        frozen: true
      })
    }
  }

  clearData() {
    this.setState({
      data: undefined
    })
  }

  validate(data) {
    this.setState({ data });
  }

  closeModal() {
    this.props.history.push({
      pathname: "/"
    })
  }

  setPageTitle = (title = '') => {
    if(title) {
      this.state.heading.suggestTitle = title;
    }
  }

  getPageTitle = () => {
    return this.state.heading.suggestTitle;
  }

  breadcrumbRoutes = (isSucess = false) => {
    const page = !isSucess ? "Suggest Charity": "Suggest Charity Confirmation";
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "Grants",
        path: "/grants"
      },
      {
        routeName: "Recommend a grant",
        path: "/grants/recommend"
      },
      {
        routeName: () => <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page={page} property="field_page_title" defaultMessage={this.getPageTitle()} />,
        path: ""
      }
    ];
  };
  
  render() {
    let { data } = this.state;

    if (data && !data.ein.includes('-'))
      data.ein = `${data.ein.substring(0, 2)}-${data.ein.substring(2, 9)}`;
    return (
      <ContentProvider data-test="charityBlock" types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_NOTICES, Types.PAGE_ALERTS]} pages={['Suggest Charity']}>
        <>
          <AlertBox
            show={this.state.frozen}
            field_page="Suggest Charity"
            name="Frozen"
            primaryBtnEvent={this.closeModal.bind(this)}
            defaultContent={this.frozenPopUp}
          />
          {data && data.isSuccess ? (
            <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION]} pages={['Suggest Charity Confirmation']}>
              <SACConfitmationPage clearData={ this.clearData.bind(this) } breadCrumb={this.breadcrumbRoutes.bind(this, true)} data={data} />
            </ContentProvider>
          ) : (
            <SuggestACharity 
              {...this.state.heading}
              redirectTo={this.props.location.state && this.props.location.state.redirectTo}
              breadCrumb={this.breadcrumbRoutes.bind(this)}
              setPageTitle={  (title) => this.setPageTitle(title)}
              getPageTitle={this.getPageTitle.bind(this)}
              validate={this.validate} />
          )}
        </>
      </ContentProvider>
    );
  }
}

export default SACComponent;
